import { environment } from './environments/environment';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import registerArrayExtensions from './app/core/extensions/array.extension';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { bootstrapApplication } from '@angular/platform-browser';
import { apiErrorInterceptor } from './app/core/interceptors/api-error-interceptor.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { provideRouter } from '@angular/router';
import { AbstractSecurityStorage, DefaultLocalStorageService } from 'angular-auth-oidc-client';
import { routes } from './app/app-routing.module';
import { authConfig } from './app/auth.config';
import { authInterceptor } from './app/core/interceptors/auth-interceptor.service';

// Customize Aura preset: use blue primary instead of default green (emerald)
const S2Preset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

if (environment.production) {
  enableProdMode();
}

registerArrayExtensions();

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    importProvidersFrom([authConfig]),
    { provide: AbstractSecurityStorage, useClass: DefaultLocalStorageService },
    provideHttpClient(
      withInterceptors([apiErrorInterceptor(), authInterceptor])
    ),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: S2Preset,
        options: {
          darkModeSelector: '.dark-mode',
        },
      },
    }),
    MessageService,
    ConfirmationService,
  ],
}).catch((err) => console.error(err));